import { render, staticRenderFns } from "./ckManage.vue?vue&type=template&id=1863af8d&scoped=true&"
import script from "./ckManage.vue?vue&type=script&lang=js&"
export * from "./ckManage.vue?vue&type=script&lang=js&"
import style0 from "./ckManage.vue?vue&type=style&index=0&id=1863af8d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1863af8d",
  null
  
)

export default component.exports